let jwt = require('jsonwebtoken');

class Auth{

    login(data, callback){
        let res = "";
        if(data && data.data){
            if(data.data.status === "success"){
                res = "SUCCESS";    
                localStorage.setItem('@Ossel:token', data.data.data.token);
                localStorage.setItem('@Ossel:authenticated', true);
                localStorage.setItem('@Ossel:userid', data.data.data.user.id);
                this.authenticated = true;
            }else if(data.data.status === "error"){
                res = "ERROR";
            }
        }
        callback(res);
    }

    logout(cb){
        localStorage.removeItem('@Ossel:token', false);
        localStorage.removeItem('@Ossel:authenticated', false);
        localStorage.removeItem('@Ossel:userid', false);
        cb();
    }

    verifyToken(token){
        jwt.verify(token, 'OSSEL@2019$inf@', function(err, decoded) {
            if (err) {
                localStorage.removeItem('@Ossel:token', false);
                localStorage.removeItem('@Ossel:authenticated', false);
                localStorage.removeItem('@Ossel:userid', false);
                return false;
            }else{
                return true
            }
        });
    }

    isAuthenticated(){
        this.verifyToken(localStorage.getItem('@Ossel:token'));
        return localStorage.getItem('@Ossel:authenticated');
    }
}

export default new Auth();


// WEBPACK FOOTER //
// ./src/auth/Auth.jsx